import { IPlan, IScore, ITask, TScoreData } from "../../../../../common/types";

export default (plan: IPlan, task: ITask): IScore => {
    let score: IScore;
    if (task.ref && plan.scores) {
        const ref = plan.scores.find(s => s._id?.toString() === task.ref!.toString());
        if (ref) {
            score = ref.score;
        }
    } else if (task.data && (task.data as TScoreData).score) {
        score = (task.data as TScoreData).score;
    }
    return score;
};
